const setSelectActiveClass = container => {
  const selects = Array.prototype.slice.call(container.querySelectorAll('.select'));

  if (selects.length > 0) {
    selects.forEach(el => {
      el.addEventListener(
        'focus',
        function () {/* eslint-disable-line */
          this.classList.add('select--focus');
        },
        true,
      );

      el.addEventListener(
        'blur',
        function () {/* eslint-disable-line */
          this.classList.remove('select--focus');
        },
        true,
      );
    });
  }
};

export default setSelectActiveClass;
